import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {User} from 'app/layout/common/user/user.types';
import {UserService} from 'app/layout/common/user/user.service';
import {AuthService} from '../../../core/auth/auth.service';

import {NgxPermissionsService} from 'ngx-permissions';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {
    showAvatar: boolean;
    user: User;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {Router} _router
     * @param {UserService} _userService
     * @param _authService
     * @param permissionsService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        public _router: Router,
        private _userService: UserService,
        private _authService: AuthService,
        private permissionsService: NgxPermissionsService,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.showAvatar = false;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    goSettings(): any {
        this.permissionsService.hasPermission('view sites').then(res => {
            const url = res ? 'settings' : 'profile';
            this._router.navigateByUrl(url);
        });
    }

    /**
     * Sign out
     *
     */
    signOut(): void {
        this._authService.signOut();
        this._router.navigate(['sign-in']);
    }
}
